import React, { useState } from 'react';
import { SendIcon, SparklesIcon } from 'lucide-react';
type TextSearchProps = {
  onSearch: (query: string) => void;
};
const exampleQueries = ['AI companies in Shenzhen with over 1000 patents', 'Electric vehicle startups founded after 2015', 'Biotech companies focused on oncology', 'Semiconductor firms in Shanghai with Series D funding'];
export function TextSearch({
  onSearch
}: TextSearchProps) {
  const [query, setQuery] = useState('');
  const handleSubmit = () => {
    if (query.trim()) {
      onSearch(query.trim());
    }
  };
  const handleKeyDown = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit();
    }
  };
  return <div className="space-y-4" data-id="element-345">
      <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-4 backdrop-blur-sm" data-id="element-346">
        <div className="flex items-start gap-3" data-id="element-347">
          <div className="p-2 bg-amber-500/10 rounded-lg mt-1" data-id="element-348">
            <SparklesIcon className="w-5 h-5 text-amber-500" data-id="element-349" />
          </div>
          <div className="flex-1" data-id="element-350">
            <textarea value={query} onChange={e => setQuery(e.target.value)} onKeyDown={handleKeyDown} placeholder="Describe what you're looking for... e.g., AI companies in Shenzhen with over 1000 patents" rows={3} className="w-full bg-transparent text-white placeholder-slate-500 outline-none resize-none text-sm leading-relaxed" data-id="element-351" />
          </div>
        </div>

        <div className="flex items-center justify-between pt-3 border-t border-slate-700 mt-3" data-id="element-352">
          <p className="text-xs text-slate-500" data-id="element-353">
            Natural language search • Press Enter to search
          </p>
          <button onClick={handleSubmit} disabled={!query.trim()} className="flex items-center gap-2 px-4 py-2 bg-amber-500 hover:bg-amber-400 disabled:bg-slate-700 disabled:text-slate-500 text-slate-900 font-semibold rounded-lg transition-colors disabled:cursor-not-allowed" data-id="element-354">
            <SendIcon className="w-4 h-4" data-id="element-355" />
            Search
          </button>
        </div>
      </div>

      <div className="space-y-2" data-id="element-356">
        <p className="text-xs text-slate-500 uppercase tracking-wider font-medium" data-id="element-357">
          Example Queries
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-2" data-id="element-358">
          {exampleQueries.map((example, index) => <button key={index} onClick={() => setQuery(example)} className="text-left px-4 py-3 bg-slate-800/30 hover:bg-slate-800/60 text-slate-400 hover:text-white rounded-lg text-sm border border-slate-700/50 hover:border-slate-600 transition-colors" data-id="element-359">
              "{example}"
            </button>)}
        </div>
      </div>
    </div>;
}